import Aos from "aos";
import React, { useEffect } from "react";
import logo from "../../assets/images/1.png";
import Flag1 from "../../assets/images/Flag (1).png";
import Flag2 from "../../assets/images/Flag (2).png";
import Flag3 from "../../assets/images/Flag (3).png";
import Flag4 from "../../assets/images/Flag (4).png";
import { Title } from "../../components";
import { Container } from "../../components/GridSystem";
import { content } from "../../contexts/useLang";

import "../../css/GlassyFrame.css";

const AboutUs = () => {
  useEffect(() => {
    Aos.init();
  }, []);
  return (
    <div>
      <Container>
        <Title title="about_us" />
        <div
          // data-aos="fade-left"
          // data-aos-delay="50"
          // data-aos-duration="750"
          className="md:h-[200px] py-5 border border-Dark rounded-3xl px-8  mx-auto bg-Light flex items-center justify-between max-md:items-start"
        >
          <div className="max-md:order-2">
            <Container>
              <div className="md:text-lg ">
                {" "}
                <img
                  src={logo}
                  alt="Brilliant Technology "
                  className="w-[70px] inline md:hidden"
                />
                {content.des_about_us_one}
              </div>
              <br />
              <div className="md:text-lg">{content.des_about_us_tow}</div>
              <div className="flex justify-center items-center gap-5">
                <img src={Flag2} alt="" className="w-16" />
                <img src={Flag3} alt="" className="w-16" />
                <img src={Flag4} alt="" className="w-12 mx-2" />
                <img src={Flag1} alt="" className="w-16" />
              </div>
            </Container>
          </div>
          <div className="max-md:order-1 mx-auto max-md:hidden">
            <img
              src={logo}
              alt="Brilliant Technology "
              className="w-[200px] object-cover "
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default AboutUs;
